<template>
    <div class="max-w-[80%] rounded-lg border border-slate-200 bg-white shadow-sm">
        <div class="flex items-center justify-between border-b border-slate-100 px-4 py-2">
            <h3 class="text-sm font-semibold text-slate-800">{{ heading }}</h3>
            <span class="rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-600">{{ data.count }}</span>
        </div>
        <div v-if="data.count === 0" class="px-4 py-3 text-xs text-slate-500">No goals to show.</div>
        <ul v-else class="divide-y divide-slate-100">
            <li v-for="goal in data.goals" :key="goal.id" class="px-4 py-3">
                <div class="flex items-start justify-between gap-3">
                    <div class="min-w-0 flex-1">
                        <div class="truncate text-sm font-medium text-slate-900">{{ goal.title }}</div>
                        <p v-if="goal.description" class="mt-0.5 line-clamp-2 text-xs text-slate-600">{{ goal.description }}</p>
                        <div v-if="goal.latest_action" class="mt-2 rounded-md bg-slate-50 px-2 py-1 text-[11px] text-slate-600">
                            <span class="font-medium text-slate-700">Next:</span> {{ goal.latest_action.title }}
                            <span v-if="goal.latest_action.status !== 'active'" class="ml-1 text-slate-500">· {{ goal.latest_action.status }}</span>
                        </div>
                    </div>
                    <div class="flex shrink-0 flex-col items-end gap-1">
                        <span :class="typeBadgeClass(goal.type)" class="rounded-full px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide">{{ goal.type }}</span>
                        <span :class="statusBadgeClass(goal.status)" class="rounded-full px-2 py-0.5 text-[10px] font-medium">{{ goal.status }}</span>
                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { GoalsListResult } from "../types";

const props = defineProps<{ result: GoalsListResult; toolName: string }>();

const data = computed<GoalsListResult>(() => props.result);

const heading = computed(() => (props.toolName === "get_archived_goals" ? "Archived goals" : "Active goals"));

const typeBadgeClass = (t: string): string => {
    if (t === "performance") {
        return "bg-amber-50 text-amber-800 ring-1 ring-amber-200";
    }
    return "bg-indigo-50 text-indigo-800 ring-1 ring-indigo-200";
};

const statusBadgeClass = (s: string): string => {
    if (s === "completed") {
        return "bg-emerald-50 text-emerald-800 ring-1 ring-emerald-200";
    }
    if (s === "archived") {
        return "bg-slate-100 text-slate-600 ring-1 ring-slate-200";
    }
    return "bg-sky-50 text-sky-800 ring-1 ring-sky-200";
};
</script>
